import React, {
  useEffect,
} from "react";

import ReactDOM from "react-dom";

import {
  FiBriefcase,
  FiCalendar,
  FiClock,
  FiEdit,
  FiKey,
  FiLock,
  FiMail,
  FiMapPin,
  FiPhone,
  FiShield,
  FiUser,
  FiX,
} from "react-icons/fi";

import EmployeeStatusBadge
  from "../common/EmployeeStatusBadge";

import {
  formatEmployeeCurrency,
  formatEmployeeDate,
  formatEmployeeLabel,
} from "../utils/employee.utils";

import "./EmployeeManagement.css";


const EmployeeDetailsDrawer = ({
  open,

  employee,

  onClose,

  onEdit,

  onChangeStatus,
}) => {

  useEffect(
    () => {

      if (
        !open
      ) {

        return undefined;

      }


      const previousOverflow =
        document
          .body
          .style
          .overflow;


      document
        .body
        .style
        .overflow =
        "hidden";


      const handleEscape = (
        event
      ) => {

        if (
          event.key ===
          "Escape"
        ) {

          onClose?.();

        }

      };


      window.addEventListener(
        "keydown",
        handleEscape
      );


      return () => {

        document
          .body
          .style
          .overflow =
          previousOverflow;


        window.removeEventListener(
          "keydown",
          handleEscape
        );

      };

    },
    [
      open,
      onClose,
    ]
  );


  if (
    !open ||
    !employee
  ) {

    return null;

  }


  const adminUser =
    employee?.userId &&
    typeof employee.userId ===
      "object"
      ?
      employee.userId
      :
      null;


  const role =
    adminUser?.roleId &&
    typeof adminUser.roleId ===
      "object"
      ?
      adminUser.roleId
      :
      null;


  const loginEnabled =
    Boolean(
      adminUser
    ) &&
    String(
      adminUser?.status ||
      ""
    ).toUpperCase() ===
    "ACTIVE";


  const permissionMode =
    String(
      adminUser?.permissionMode ||
      "ROLE"
    ).toUpperCase();


  const customPermissions =
    Array.isArray(
      adminUser?.permissions
    )
      ?
      adminUser.permissions
      :
      [];


  return ReactDOM
    .createPortal(

      <div className="employee-view-root">

        <button
          type="button"
          className="employee-view-backdrop"
          onClick={
            onClose
          }
          aria-label="Close"
        />


        <aside className="employee-view-drawer">

          <header className="employee-view-header">

            <div>

              <span>
                EMPLOYEE PROFILE
              </span>

              <h2>
                Employee Details
              </h2>

            </div>


            <button
              type="button"
              onClick={
                onClose
              }
            >
              <FiX />
            </button>

          </header>


          <div className="employee-view-body">

            <section className="employee-view-profile">

              <div className="employee-view-avatar">

                {
                  employee.profileImage
                    ?
                    (
                      <img
                        src={
                          employee.profileImage
                        }
                        alt={
                          employee.name
                        }
                      />
                    )
                    :
                    (
                      <FiUser />
                    )
                }

              </div>


              <div className="employee-view-profile-info">

                <span>
                  {
                    employee.employeeCode ||
                    "-"
                  }
                </span>

                <h3>
                  {
                    employee.name
                  }
                </h3>

                <p>
                  {
                    employee.designation ||
                    "-"
                  }
                  {" • "}
                  {
                    employee.department ||
                    "-"
                  }
                </p>

              </div>


              <EmployeeStatusBadge
                status={
                  employee.status
                }
              />

            </section>


            <ViewSection title="Contact Information">

              <div className="employee-view-grid">

                <DetailItem
                  icon={FiPhone}
                  label="Mobile"
                  value={
                    employee.mobile
                  }
                />

                <DetailItem
                  icon={FiMail}
                  label="Email"
                  value={
                    employee.email
                  }
                />

              </div>

            </ViewSection>


            <ViewSection title="Employment Information">

              <div className="employee-view-grid">

                <DetailItem
                  icon={FiBriefcase}
                  label="Department"
                  value={
                    employee.department
                  }
                />

                <DetailItem
                  icon={FiBriefcase}
                  label="Designation"
                  value={
                    employee.designation
                  }
                />

                <DetailItem
                  icon={FiBriefcase}
                  label="Employment Type"
                  value={
                    formatEmployeeLabel(
                      employee.employmentType
                    )
                  }
                />

                <DetailItem
                  icon={FiCalendar}
                  label="Joining Date"
                  value={
                    formatEmployeeDate(
                      employee.joiningDate
                    )
                  }
                />

              </div>

            </ViewSection>


            <ViewSection title="Current Salary Structure">

              <div className="employee-view-salary-grid">

                <SalaryItem
                  label="Basic Salary"
                  value={
                    employee
                      ?.salary
                      ?.basicSalary
                  }
                />

                <SalaryItem
                  label="Allowances"
                  value={
                    employee
                      ?.salary
                      ?.allowances
                  }
                />

                <SalaryItem
                  label="Deductions"
                  value={
                    employee
                      ?.salary
                      ?.deductions
                  }
                />

                <SalaryItem
                  label="Net Salary"
                  value={
                    employee
                      ?.salary
                      ?.netSalary
                  }
                  highlight
                />

              </div>

            </ViewSection>


            <ViewSection title="Login & Access">

              {
                adminUser
                  ?
                  (
                    <div className="employee-view-access-grid">

                      <DetailItem
                        icon={FiLock}
                        label="Login Access"
                        value={
                          loginEnabled
                            ?
                            "Enabled"
                            :
                            "Disabled"
                        }
                      />

                      <DetailItem
                        icon={FiShield}
                        label="Role"
                        value={
                          role?.name ||
                          "-"
                        }
                      />

                      <DetailItem
                        icon={FiKey}
                        label="Permission Mode"
                        value={
                          formatEmployeeLabel(
                            permissionMode
                          )
                        }
                      />

                      <DetailItem
                        icon={FiClock}
                        label="Last Login"
                        value={
                          adminUser.lastLogin
                            ?
                            formatEmployeeDate(
                              adminUser.lastLogin
                            )
                            :
                            "-"
                        }
                      />

                    </div>
                  )
                  :
                  (
                    <div className="employee-view-no-login">

                      <FiLock />

                      <div>

                        <strong>
                          No Login Account
                        </strong>

                        <span>
                          This employee cannot currently access the admin portal.
                        </span>

                      </div>

                    </div>
                  )
              }


              {
                adminUser &&
                permissionMode ===
                  "CUSTOM"
                  ?
                  (
                    <div className="employee-view-permissions">

                      <div>

                        <strong>
                          Custom Permissions
                        </strong>

                        <span>
                          {
                            customPermissions.length
                          }
                        </span>

                      </div>


                      <div className="employee-view-permission-list">

                        {
                          customPermissions.map(
                            (
                              permission
                            ) => (

                              <span
                                key={
                                  permission?._id ||
                                  permission
                                }
                              >

                                {
                                  permission?.name ||
                                  permission?.code ||
                                  String(
                                    permission
                                  )
                                }

                              </span>

                            )
                          )
                        }

                      </div>

                    </div>
                  )
                  :
                  null
              }

            </ViewSection>


            <ViewSection title="Address">

              <div className="employee-view-address">

                <FiMapPin />

                <div>

                  <strong>
                    {
                      employee
                        ?.address
                        ?.addressLine ||
                      "-"
                    }
                  </strong>

                  <span>

                    {
                      [
                        employee?.address?.city,
                        employee?.address?.state,
                        employee?.address?.pincode,
                      ]
                        .filter(
                          Boolean
                        )
                        .join(
                          ", "
                        ) ||
                      "-"
                    }

                  </span>

                </div>

              </div>

            </ViewSection>

          </div>


          <footer className="employee-view-footer">

            <button
              type="button"
              className="employee-view-status-button"
              onClick={
                () =>
                  onChangeStatus?.(
                    employee
                  )
              }
            >

              <FiShield />

              Change Status

            </button>


            <button
              type="button"
              className="employee-view-edit-button"
              onClick={
                () =>
                  onEdit?.(
                    employee
                  )
              }
            >

              <FiEdit />

              Edit Employee

            </button>

          </footer>

        </aside>

      </div>,

      document.body

    );

};


const ViewSection = ({
  title,
  children,
}) => (

  <section className="employee-view-section">

    <h4>
      {title}
    </h4>

    {children}

  </section>

);


const DetailItem = ({
  icon: Icon,
  label,
  value,
}) => (

  <div className="employee-view-detail-item">

    <span>
      <Icon />
    </span>

    <div>

      <small>
        {label}
      </small>

      <strong>
        {value || "-"}
      </strong>

    </div>

  </div>

);


const SalaryItem = ({
  label,
  value,
  highlight,
}) => (

  <div
    className={
      highlight
        ?
        "employee-view-salary-item highlight"
        :
        "employee-view-salary-item"
    }
  >

    <span>
      {label}
    </span>

    <strong>
      {
        formatEmployeeCurrency(
          value
        )
      }
    </strong>

  </div>

);


export default EmployeeDetailsDrawer;